// mixpanel events
export const TRACK_ADOPTION_METRICS_FOR_CONVERSATION_CLICKED_EVENT = "Conversation Clicked";
export const TRACK_ADOPTION_METRICS_FOR_CONVERSATION_VIEWED_EVENT = "Conversation Viewed";
export const TRACK_ADOPTION_METRICS_FOR_ASSET_DETAIL_VIEWED_EVENT = "Asset Detail Viewed";
export const TRACK_ADOPTION_METRICS_FOR_STREAM_DETAIL_VIEWED_EVENT = "Stream Detail Viewed";
export const TRACK_ADOPTION_METRICS_FOR_COLLECTION_DETAIL_VIEWED_EVENT = "Collection Detail Viewed";
export const TRACK_ADOPTION_METRICS_FOR_CONTENT_SEARCHED_EVENT = "Content Searched";
export const TRACK_ADOPTION_METRICS_FOR_SEEK_VIEW_CLICKED_EVENT = "Seek View Clicked";
export const TRACK_ADOPTION_METRICS_FOR_NEW_CHAT_CLICKED_EVENT = "New Chat Clicked";
export const TRACK_ADOPTION_METRICS_FOR_SEARCH_REACTED_EVENT = "Search Reacted";

export const TRACK_EVENT_FOR_ADOPTION_REQUEST = "Track Event For Adoption Request";
export const TRACKING_EVENT_FOR_ADOPTION_REQUEST = "Tracking Event For Adoption Request";
export const TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED = "Tracking Event For Adoption Succeeded";
export const TRACKING_EVENT_FOR_ADOPTION_FAILED = "Tracking Event For Adoption Failed";
export const TRACK_ADOPTION_METRICS_FOR_GENERATE_LINK_EVENT = "Get Link Clicked";
export const TRACK_ADOPTION_METRICS_FOR_SESSION_START_EVENT  = "Session Start";

export const TRACK_ADOPTION_METRICS_FOR_MEETING_PREP_CLICKED_EVENT = "Meeting Prep Clicked";
export const TRACK_ADOPTION_METRICS_FOR_LEARN_MORE_CLICKED_EVENT = "Learn More Clicked";
